import { FC, HTMLAttributes } from 'react';

export interface H1Props extends HTMLAttributes<HTMLHeadingElement> {}

export const H1: FC<H1Props> = ({ children, className }) => {
  return <h1 className={`h1 ${className}`}>{children}</h1>;
};
